module.exports = __webpack_public_path__ + "img/student-default-boy.518bbe32.png";